import React, { useState } from "react";
import { ReactComponent as PowerPointIcon } from "assets/img/icons/powerpoint.svg";
import { ReactComponent as WordIcon } from "assets/img/icons/doc.svg";
import { ReactComponent as ExcelIcon } from "assets/img/icons/excel.svg";
import { ReactComponent as TextIcon } from "assets/img/icons/textFile.svg";
import { ReactComponent as PdfIcon } from "assets/img/icons/pdf.svg";
import { ReactComponent as RtfIcon } from "assets/img/icons/rtf.svg";
import { ReactComponent as CsvIcon } from "assets/img/icons/csv.svg";
import { ReactComponent as DownloadIcon } from "assets/img/icons/downloadIcon.svg";
import DocumentDisplay from "components/DocumentDisplay";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import fileDownload from "js-file-download";
import Axios from "axios";

const useStyle = {
  content: {
    width: "100%",
    padding: "10px",
    background: "#F2F2F7",
    border: "none",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fileText: {
    color: "black",
    fontSize: "12px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
    maxWidth: "inherit",
    padding: "0px 10px",
  },
  previewDialog: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "1100",
    color: "black",
  },
  previewDialogBackdrop: {
    height: "inherit",
    width: "inherit",
    position: "fixed",
    backgroundColor: "black",
    top: "0",
    left: "0",
    zIndex: "-1",
    pointerEvents: "none",
    opacity: "0.7",
  },

  closeContainer: {
    padding: "20px",
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: "2",
  },
  closeIcon: {
    width: "25px",
    cursor: "pointer",
    fill: "white",
  },
  anchorFile: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    pointerEvents: "none",
  },
  icon: {
    width: "25px",
  },
};

export default ({ expression }) => {
  const classes = useStyle;
  const [previewDialog, setShowPreviewDialog] = useState(false);

  const DocumentIcon = ((name) => {
    let fileName = name.split(".");

    if (["doc", "docx"].includes(fileName[1])) {
      return <WordIcon style={classes.icon} />;
    }

    if (["xls", "xlsx"].includes(fileName[1])) {
      return <ExcelIcon style={classes.icon} />;
    }

    if (["csv"].includes(fileName[1])) {
      return <CsvIcon style={classes.icon} />;
    }

    if (["pdf"].includes(fileName[1])) {
      return <PdfIcon style={classes.icon} />;
    }

    if (["ppt", "pptx"].includes(fileName[1])) {
      return <PowerPointIcon style={classes.icon} />;
    }

    if (["txt"].includes(fileName[1])) {
      return <TextIcon style={classes.icon} />;
    }

    if (["rtf"].includes(fileName[1])) {
      return <RtfIcon style={classes.icon} />;
    }

    return null;
  })(expression.media_name);

  const showPreviewDailog = () => {
    document.getElementById("right-sidebar").style.zIndex = "-1";
    document.getElementById("footer").style.zIndex = "-1";
    document.getElementById("header").style.zIndex = "-1";
    setShowPreviewDialog(true);
  };

  const closePreviewDailog = () => {
    document.getElementById("right-sidebar").style.zIndex = "1";
    document.getElementById("footer").style.zIndex = "1";
    document.getElementById("header").style.zIndex = "1";
    setShowPreviewDialog(false);
  };

  const downloadFile = () => {
    Axios.get(expression.media, {
      responseType: "blob",
    }).then((res) => {
      fileDownload(res.data, expression.media_name);
    });
  };

  return (
    <>
      <div>
        <div style={classes.content}>
          <div
            onClick={() => showPreviewDailog(true)}
            style={classes.anchorFile}
          >
            <div>{DocumentIcon}</div>
            <span style={classes.fileText}>{expression.media_name}</span>
          </div>
          <div>
            <DownloadIcon
              style={{ width: "20px", cursor: "pointer" }}
              onClick={downloadFile}
            />
          </div>
        </div>
      </div>
      {previewDialog && (
        <div style={classes.previewDialog} onClick={closePreviewDailog}>
          <div style={classes.previewDialogBackdrop}></div>
          <div style={classes.closeContainer}>
            <CloseIcon style={classes.closeIcon} onClick={closePreviewDailog} />
          </div>
          <div
            className="imagePreviewContentContainer"
            style={{ width: "100%", maxWidth: "unset" }}
          >
            <DocumentDisplay
              documentSrc={expression?.media}
              documentName={expression.media_name}
            />
          </div>
        </div>
      )}
    </>
  );
};
